import { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { IconWrapperProps } from '../libs.interfaces';
import { ReactSVG } from 'react-svg';

const ENV = (import.meta as any).env;

export function IconWrapper(props: IconWrapperProps) {
  const { iconName, className = '', style = {} } = props;
  const [svgContent, setSvgContent] = useState('');
  
  useEffect(() => {
    if (ENV?.VITE_APP_IS_WEB === 'true') { return }

    if (!iconName || iconName === '') { return }

    

    // Use the original, simple path that already works
    fetch(`icons/${iconName}.svg`)
      .then(response => response.text())
      .then(svgText => {
        setSvgContent(svgText);
      })
      .catch(error => {
        console.error(`Failed to load icon ${iconName}:`, error);
      });
  }, [iconName]);

  if (iconName === 'shared_energy') {
    console.log('iconName', iconName);
  }

  if (ENV?.VITE_APP_IS_WEB === 'true') {
    return <ReactSVG src={`icons/${iconName}.svg`} className={`${className}`} style={style} />;
  } else {
    return (
      <div className={className} style={style}>
        {svgContent ? parse(svgContent) : ''}
      </div>
    );
  }
  
  
}

export default IconWrapper;
